import { render, staticRenderFns } from "./CrmBotChats.vue?vue&type=template&id=05ab9f5a&scoped=true"
import script from "./CrmBotChats.vue?vue&type=script&lang=js"
export * from "./CrmBotChats.vue?vue&type=script&lang=js"
import style0 from "./CrmBotChats.vue?vue&type=style&index=0&id=05ab9f5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ab9f5a",
  null
  
)

export default component.exports